// import { useState, useEffect } from "react";
import { useRef, useState, useMemo } from "react";
import { Modal, Frame, TitleBar, Button, Tooltip } from "@react95/core";

import {
  Textchat,
  Mailnews12,
  BatExec2,
  FilePick,
  Mailnews8,
  HelpBook,
  Wab321011,
  Awfext326053,
  Wmsui323911,
  Msnstart1,
  Progman21,
  Smmscrpt100,
  Wmsui321306,
  Shell32147,
} from "@react95/icons";

import { useApp } from "../../context/AppContext";

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

import { AboutProjectsDef } from "./AboutProjects";

export const AboutWindowDef = {
  id: WINDOW_NAMES.AboutMe,
  title: "About",
  icon: <Textchat variant="16x16_4" />,
  hasButton: true,
};

export default function Domenic() {
  const { openModal, closeModal } = useApp();

  const sizeProps = useMemo(() => getModalSizeProps("auto", "350px", "center-top"), []);
  const icon = useMemo(() => AboutWindowDef.icon, []);
  
  // `showCredits` toggles visibility of the credits section
  const [showCredits, setShowCredits] = useState(false);

  const socialLinks = [
    {
      // icon: <FilePick variant="32x32_4" />,
      icon: <Progman21 variant="32x32_4" />,
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/domenichorner/",
    },
    {
      icon: <BatExec2 variant="32x32_4" />,
      label: "GitHub",
      url: "https://github.com/tgxn",
    },
    {
      icon: <Smmscrpt100 variant="32x32_4" />,
      label: "Discord",
      url: "https://discord.com/users/128495405980844032",
    },
    {
      icon: <Mailnews8 variant="32x32_4" />,
      label: "Blog",
      url: "https://blog.tgxn.net",
    },
  ];

  // `creditsInformation` shown when the user expands the credits section
  const creditsInformation = (
    <div style={{ textAlign: "left", fontSize: "12px", color: "#333" }}>
      <strong>Thanks to:</strong>
      <ul style={{ paddingLeft: "1rem", margin: "0.5rem 0" }}>
        <li>
          <a href="https://github.com/React95/React95" target="_blank">
            React95
          </a>{" "}
          for the UI components
        </li>
        <li>
          <a href="https://github.com/pi0/clippyjs" target="_blank">
            ClippyJS
          </a>
          /
          <a href="https://github.com/lizozom/clippyts" target="_blank">
            TS
          </a>{" "}
          for the Clippy assistants
        </li>
        <li>
          <a href="https://microsoft.com" target="_blank">
            Microsoft
          </a>{" "}
          owns all the icons used here not attribuited elsewhere.
        </li>
        <li>
          <a href="https://github.com/tholman/cursor-effects" target="_blank">
            tholman
          </a>{" "}
          for bringing the DHTML cursor effects to modern browsers.
        </li>
        <li>
          <a href="https://en.wikipedia.org/wiki/Neko_%28software%29" target="_blank">
            Neko
          </a>{" "}
          for the inspiration behind neko
        </li>
        <li>
          {" "}
          <Tooltip text="and for putting up with me ❤️‍🔥">
            My fronds, for their testing and ideas.
          </Tooltip>
        </li>
      </ul>
    </div>
  );

  const gridColumns = Math.min(4, socialLinks.length);

  return (
    <Modal
      key={AboutWindowDef.id}
      id={AboutWindowDef.id}
      icon={icon}
      title={AboutWindowDef.title}
      dragOptions={sizeProps.dragOptions}
      titleBarOptions={[
        <Modal.Minimize key="minimize" />,
        <TitleBar.Close key="close" onClick={() => closeModal(AboutWindowDef.id)} />,
      ]}
      hasWindowButton={AboutWindowDef.hasButton}
      height={sizeProps.height}
      width={sizeProps.width}
    >
      <Frame
        padding="8px"
        paddingTop="16px"
        boxShadow="$in"
        overflow="auto"
        backgroundColor="#fafafa"
        backgroundImage="url('/back.png')"
        flexGrow={1}
        fontSize="11px"
        style={{
          flex: 1,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div style={{ userSelect: "text" }}>
          <h2 style={{ padding: "0 0 0.5rem 0", fontSize: "18px" }}>
            Dom H <i style={{ fontStyle: "italic" }}>(tgxn)</i>
          </h2>
          <p style={{ margin: "0.5rem 0", fontSize: "12px", color: "#666" }}>
            Perth, Western Australia
          </p>
          <a
            href="mailto:me@domenic.au"
            style={{
              color: "#0066cc",
              textDecoration: "none",
              fontSize: "12px",
              display: "inline-flex",
              alignItems: "center",
              gap: "2px",
              justifyContent: "center",
              borderRadius: "6px",
              padding: "3px 6px",
              transition: "background 0.2s, box-shadow 0.2s, backdrop-filter 0.2s",
            }}
            onMouseOver={(e) => {
              (e.currentTarget as HTMLElement).style.backgroundColor =
                "rgba(224,224,224,0.65)";
              (e.currentTarget as HTMLElement).style.backdropFilter = "blur(3px)";
              (e.currentTarget as HTMLElement).style.boxShadow =
                "0 2px 8px 0 rgba(0,0,0,0.10)";
            }}
            onMouseOut={(e) => {
              (e.currentTarget as HTMLElement).style.backgroundColor = "transparent";
              (e.currentTarget as HTMLElement).style.backdropFilter = "none";
              (e.currentTarget as HTMLElement).style.boxShadow = "none";
            }}
          >
            <Mailnews12 variant="16x16_4" /> me@domenic.au
          </a>
        </div>

        <hr
          style={{
            marginTop: 15,
            paddingBottom: 15,
            border: "none",
            borderTop: "1px solid #ccc",
          }}
        />

        <div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
              gap: "0.75rem",
              justifyItems: "center",
              alignItems: "center",
              maxWidth: `${gridColumns * 70}px`,
              margin: "0 auto",
              width: "100%",
            }}
          >
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                style={{
                  color: "#0066cc",
                  textDecoration: "none",
                  fontSize: "12px",
                  padding: "0.5rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.25rem",
                  width: "100%",
                }}
                // hover
                onMouseOver={(e) => {
                  // set a semi-transparent, glassy background on hover
                  (e.currentTarget as HTMLElement).style.backgroundColor =
                    "rgba(224,224,224,0.65)";
                  (e.currentTarget as HTMLElement).style.backdropFilter = "blur(3px)";
                  (e.currentTarget as HTMLElement).style.boxShadow =
                    "0 2px 8px 0 rgba(0,0,0,0.10)";
                }}
                onMouseOut={(e) => {
                  // reset background and effects on mouse out
                  (e.currentTarget as HTMLElement).style.backgroundColor = "transparent";
                  (e.currentTarget as HTMLElement).style.backdropFilter = "none";
                  (e.currentTarget as HTMLElement).style.boxShadow = "none";
                }}
              >
                <span style={{ fontSize: "18px", lineHeight: 1 }}>
                  {/* overlay the `Wmsui321306` icon on top of the main icon */}
                  <span
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "32px",
                      height: "32px",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 1,
                      }}
                    >
                      {link.icon}
                    </span>
                    <span
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 2,
                        pointerEvents: "none",
                      }}
                    >
                      <Wmsui321306 variant="32x32_4" />
                    </span>
                  </span>
                </span>
                <span style={{ fontSize: "12px" }}>{link.label}</span>
              </a>
            ))}
          </div>

          {/* <Button
              aria-expanded={showCredits}
              onClick={() => openModal(AboutProjectsDef)}
              style={{
                marginTop: "8px",
                width: "100%",
                padding: "6px 10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <Shell32147 variant="16x16_4" />
              <span style={{ fontSize: "13px" }}>My Projects</span>
            </Button> */}

          <hr
            style={{
              marginTop: 15,
              // paddingBottom: 15,
              border: "none",
              borderTop: "1px solid #ccc",
            }}
          />

          {/* credits toggle and expandable area */}
          <div
            style={{
              marginTop: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <Button
              aria-expanded={showCredits}
              onClick={() => setShowCredits((s) => !s)}
              style={{
                width: "100%",
                padding: "6px 10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              {showCredits ? (
                <>
                  <Wab321011 variant="16x16_4" />
                  <span style={{ fontSize: "13px" }}>Hide Credits</span>
                </>
              ) : (
                <>
                  <HelpBook variant="16x16_4" />
                  <span style={{ fontSize: "13px" }}>Credits</span>
                </>
              )}
            </Button>

            {showCredits && (
              <Frame
                boxShadow="$in"
                p="$8"
                backgroundColor="#fff"
                flexGrow={1}
                fontSize="11px"
                style={{
                  flex: 1,
                  textAlign: "center",
                  width: "100%",
                }}
              >
                {creditsInformation}
              </Frame>
            )}
          </div>
        </div>
      </Frame>
    </Modal>
  );
}
